module.exports = __webpack_public_path__ + "media/1x1/sn-d2bec7ef.svg";